export const savedFormState = (app, model) => (state) =>
  state.formState[`${app}-${model}`] || {}
